<template>
  <div class="box-father">
    <div class="section">
      <div class="right">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="事项目标名称">
                  <el-input
                    v-model="form.sxmc"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所在社区">
                  <el-input
                    v-model="form.communityName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="巡查状态">
                  <el-select
                    filterable
                    placeholder="全部"
                    clearable
                    v-model="bmmc"
                    @change="onSearch"
                  >
                    <el-option
                      v-for="(item, index) in bmmcList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <common-table
            :select="false"
            :maxHeight="460"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          >
            <template v-slot:xm="{ scope }">
              <span>{{ scope.row.extendBusinessInfo && scope.row.extendBusinessInfo.xm }}</span>
            </template>
            <template v-slot:communityName="{ scope }">
              <span>{{ scope.row.communityName }}</span>
            </template>
            <template v-slot:lxdh="{ scope }">
              <span>{{ scope.row.extendBusinessInfo && scope.row.extendBusinessInfo.lxdh }}</span>
            </template>
            <template v-slot:jzdz="{ scope }">
              <span>{{ scope.row.extendBusinessInfo && scope.row.extendBusinessInfo.jzdz }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="openIssuesDialogFun(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >详情</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import {
  getCommcommunityAll,
  extendTaskPage,
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable,
  },
  props: {
    curTypeItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        sxmc: "",
        communityName: "",
      },
      date: [],
      bmmc: "",
      bmmcList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待巡查',
          value: '待执行'
        },
        {
          label: '已巡查',
          value: '已完成'
        }
      ],
      dialogVisible: false,
      ruleDialogVisible: false,
      issuesDialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            slot: "xm",
            label: "事项目标名称"
          },
          {
            slot: "communityName",
            label: "所在社区"
          },
          {
            slot: "lxdh",
            label: "联系方式"
          },
          {
            slot: "jzdz",
            label: "目标地址"
          },
          {
            prop: "taskStatus",
            label: "巡查状态"
          },
          {
            slot: "operation",
            label: "操作",
          }
        ]
      },
      curItem: {},
      ruleCurItem: {},
      issuesCurItem: {},
      typeList: [],
      ghEventTypeId: null,
      exportLoading: false,
    };
  },
  mounted() {
    this.eventPageFun();
    // this.getCommcommunityAll();
  },
  methods: {
    openIssuesDialogFun(item) {
      this.$emit('showChild', {
        type: 2,
        id: item.id,
        eventTypeName: item.eventTypeName
      })
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.eventPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.eventPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    onReset() {
      this.form.sxmc = "";
      this.form.communityName = "";
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    // 分页查询
    async eventPageFun() {
      let params = {
        extendBatchName: this.curTypeItem.batchName,
        extendSearchKeyword: this.form.sxmc,
        communityName: this.form.communityName,
        extendFillBussinessInfoFlag: true,
        page: this.page.page,
        size: this.page.size,
        taskStatus: this.bmmc
      };
      const res = await extendTaskPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  padding: 0 !important;
  padding-bottom: 24px;
  margin-top: 10px;
  .section {
    display: flex;
    padding: 0;

    .right {
      width: 100%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100% - 94px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin: 0 8px 6px 0;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .edit {
        width: 140px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/noPatrolReport/list.vue